query AnalyticsViewsByUtm($filter: AnalyticsViewsFilterInput!, $dimension: UtmDimension!) {
  analyticsViews(filter: $filter) {
    viewsByUtm(dimension: $dimension) {
      value
      views
    }
  }
}
